import { AuthenticationService, AuthenticationResponse } from './AuthenticationService';
import { fetchExactOnlineAuthorizationCode } from './ApiService';

export class ExactOnlineAuthService implements AuthenticationService {

  async getAuthorizationUrl(
    redirectTo: string = "nieuwe-koppeling",
    systemAuthorizationId?: number
  ): Promise<AuthenticationResponse> {
    const { data, error } = await fetchExactOnlineAuthorizationCode(redirectTo, systemAuthorizationId);

    if (error) {
      return {
        success: false,
        error: "Fout bij het ophalen van de authenticatiecode."
      };
    }

    if (typeof data === 'string') {
      return {
        success: true,
        data: data,
        message: "Authenticatie vereist. U wordt doorgestuurd..."
      };
    } else if (data.message === 'success') {
      return {
        success: true,
        data: data,
      };
    }

    return {
      success: false,
      error: "Onbekende reactie van de server."
    };
  }

  async checkAuthenticationStatus(
    redirectTo: string = "nieuwe-koppeling",
    systemAuthorizationId?: number
  ): Promise<AuthenticationResponse> {
    const { data, error } = await fetchExactOnlineAuthorizationCode(redirectTo, systemAuthorizationId);

    if (error) {
      return {
        success: false,
        error: "Fout bij het controleren van de authenticatiestatus."
      };
    }

    if (data.message === 'success') {
      return {
        success: true,
        data,
      };
    }

    return {
      success: false,
      message: "Authenticatie vereist."
    };
  }
}
